import dayjs from 'dayjs';
import 'dayjs/locale/th';
import moment from 'moment';

const ALL_CLASS_SELECTED = 'all-class-selected';
export const ALL_LESSON_SELECTED = 'all-lesson-selected';

/**
 * Lesson is filtered by its name, because quiz feed tables have only lesson name.
 * `lessonName` is set only when a lesson is selected.
 * @param {object} value filter value from AttendanceFilterData or query string
 * @returns {object} variables of getQuizFeedReport query
 */
export const toQuizFeedReportVariables = ({
  term,
  grade,
  classNo,
  subject,
  syllabus,
  lessonName,
}) => ({
  schoolTermId: term,
  schoolGradeId: grade,
  classNo: classNo && classNo !== ALL_CLASS_SELECTED ? classNo : null,
  subjectId: subject,
  courseCode: syllabus,
  lessonName: lessonName || null,
});

/**
 * @param {{ correct: number, total: number } | null} score
 * @returns {string} ex. 12/15, or - when there is no score
 */
export const formatQuizFeedScore = score => (score ? `${score.correct}/${score.total}` : '-');

/**
 * @param {{ accuracy: number } | null} score
 * @returns {string} ex. 80%, or 0% when there is no score
 */
export const formatQuizFeedAccuracy = score => `${score?.accuracy ?? 0}%`;

/**
 * Date is always in Thai with 2-digit year in C.E., e.g. 15 พ.ค. 26 / 11:00-11:45,
 * the date of end time is shown only when it is not the same day as start time
 * @param {string | null} startedAt
 * @param {string | null} endedAt
 * @returns {string} date and time of an attempt, or - when it has no start time
 */
export const formatAttemptDateTime = (startedAt, endedAt) => {
  if (!startedAt) return '-';
  const formatDateTime = time => time.locale('th').format('D MMM YY / HH:mm');
  const start = dayjs(startedAt);
  if (!endedAt) return formatDateTime(start);
  const end = dayjs(endedAt);
  if (!end.isSame(start, 'day')) return `${formatDateTime(start)} - ${formatDateTime(end)}`;
  return `${formatDateTime(start)}-${end.format('HH:mm')}`;
};

/**
 * @param {{ firstName?: string, lastName?: string }} student
 * @returns {string} ex. อภิชา กุสุมลกุล
 */
export const getStudentDisplayName = ({ firstName, lastName }) =>
  [firstName, lastName].filter(Boolean).join(' ');

/**
 * @returns {string} current time, ex. 20/05/2026 21:15
 */
export const getUpdateTime = () => {
  return moment().format('DD/MM/YYYY HH:mm');
};
